
/**
 * 
 * 获取当天日期
 * @returns  YYYY-MM-DD 格式
 */
export function getDefaultDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const now = `${year}-${month}-${day}`;
    return now
  }
  
  /**
   * 
   * 获取昨天日期
   * @returns   YYYY-MM-DD 格式
   */
  export function getYesterdayDate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
  
    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, '0');
    const day = String(yesterday.getDate()).padStart(2, '0');
  
    const yesterdayDate = `${year}-${month}-${day}`;
    return yesterdayDate;
  }
  
  /**
   * 获取本周的开始时间和结束日期
   * @returns   YYYY-MM-DD 格式的开始时间和结束时间
   */
  export function getStartAndEndOfWeek() {
   
    const today = new Date();
    const currentDayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
  
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - currentDayOfWeek + 1);
  
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + (6 - currentDayOfWeek + 1));
  
    const startYear = startDate.getFullYear();
    const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
    const startDay = String(startDate.getDate()).padStart(2, '0');
    const endYear = endDate.getFullYear();
    const endMonth = String(endDate.getMonth()+1).padStart(2, '0');
    const endDay = String(endDate.getDate()).padStart(2, '0');
  
    const startOfWeek = `${startYear}-${startMonth}-${startDay}`;
    const endOfWeek = `${endYear}-${endMonth}-${endDay}`;
  
    return { startOfWeek, endOfWeek };
  }
  
  
  /**
   * 
   * 获取前一周的 开始时间和结束日期
   * @returns  YYYY-MM-DD 格式的开始时间和结束时间
   */
  export function getPreviousWeekDates() {
    const today = new Date();
    const currentDay = today.getDay(); // 0 (Sunday) to 6 (Saturday)
  
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - currentDay - 6); // Start from last Sunday
  
    const endDate = new Date(today);
    endDate.setDate(today.getDate() - currentDay); // End on last Saturday
  
    const startYear = startDate.getFullYear();
    const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
    const startDay = String(startDate.getDate()).padStart(2, '0');
  
    const endYear = endDate.getFullYear();
    const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
    const endDay = String(endDate.getDate()).padStart(2, '0');
  
    const startDateString = `${startYear}-${startMonth}-${startDay}`;
    const endDateString = `${endYear}-${endMonth}-${endDay}`;
  
    return { startDate: startDateString, endDate: endDateString };
  }


  /**
   * 获取今天是周几
   */
  export function getDayOfWeek(){
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const today = new Date();
    const dayOfWeekNumber = today.getDay();
    const dayOfWeek = daysOfWeek[dayOfWeekNumber];
    return dayOfWeek;
  }


  /**
   * 
   * 获取上周五的日期
   * @returns  返回上周五的yyyy-MM-dd格式
   */
  export function getPreviousFriday() {
    const today = new Date();
    const currentDay = today.getDay(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday
  
    const daysUntilFriday = (currentDay + 2) % 7; // Calculate days until previous Friday
    const previousFriday = new Date(today); // Create a copy of the current date
    previousFriday.setDate(today.getDate() - daysUntilFriday); // Subtract days to get previous Friday
  
    const year = previousFriday.getFullYear();
    const month = String(previousFriday.getMonth() + 1).padStart(2, '0');
    const day = String(previousFriday.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }
